import { Divider, Box } from '@mui/material'

const OrAuthSection = () => {
  return (
    <Box my="30px" display="flex" alignItems="center" gap="16px">
      <Box flex="1">
        <Divider />
      </Box>
      <Box>
        <span style={{ fontWeight: 700, fontSize: '20px' }}>or</span>
      </Box>
      <Box flex="1">
        <Divider />
      </Box>
    </Box>
  )
}

export default OrAuthSection
